import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {PageManager} from "../interface/page-manager";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {ListResponse} from "../interface/response/list-response";

@Injectable({
  providedIn: 'root'
})
export class FileManagerPageService {
  private readonly fileManagerPageListSubject: ReplaySubject<CountedAndPaginated<PageManager>>
    = new ReplaySubject<CountedAndPaginated<PageManager>>(1);
  private readonly fileManagerPageNotCountedListSubject: ReplaySubject<ListResponse<PageManager>> = new ReplaySubject<ListResponse<PageManager>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public getFileManagerPageListSubject(): ReplaySubject<CountedAndPaginated<PageManager>> {
    return this.fileManagerPageListSubject;
  }

  public loadList(filters: object , page: number, pageSize: number,  sort?: { sortBy?: string; sortOrder?: string}): void {
    this.httpClient.get(`/rest/crm/file-manager/page?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<PageManager>) => {
        this.fileManagerPageListSubject.next(result);
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: ReplaySubject<ListResponse<PageManager>>): void {
    this.httpClient
      .get(`/rest/crm/file-manager/page?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<PageManager>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.fileManagerPageNotCountedListSubject.next(result);
        }
      });
  }


  public sendPage(formData: object, pageId: string): Observable<any> {
    if (!pageId) {
      return this.httpClient.post(`/rest/crm/file-manager/page`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm/file-manager/page/${pageId}`, formData)
        .pipe(take(1));
    }
  }

  public deletePage(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/file-manager/page/${uuid}`)
      .pipe(first());
  }

  get(pageId: string): Observable<PageManager> {
    return this.httpClient.get(`/rest/crm/file-manager/page/${pageId}`)
      .pipe(first()) as Observable<PageManager>;
  }
}
